/**
 * Role codes as the panels spell them. The API compares roles ignoring case, but the
 * panels compared them exactly, so an account whose role comes back as "SUPERADMIN"
 * (Bill's abwiggins admin account, 2026-11-04) saw only Home. Every panel runs the
 * roles it receives through canonicalRoleCode, so a role matches whatever its case.
 */
export const KNOWN_ROLE_CODES = [
  'SuperAdmin',
  'Admin',
  'RetailAdmin',
  'SysOpsManager',
  'SystemOps',
  'SysOps',
  'RiskManager',
  'Risk',
  'DisclosureManager',
] as const;

const BY_LOWER = new Map<string, string>(KNOWN_ROLE_CODES.map((r) => [r.toLowerCase(), r]));

/** The panels' spelling of a role code; an unknown code comes back trimmed and otherwise unchanged. */
export function canonicalRoleCode(code: string): string {
  const t = code.trim();
  return BY_LOWER.get(t.toLowerCase()) ?? t;
}
